var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":"Copy","type":"is-light"}},[_c('b-button',{staticStyle:{"padding-top":"inherit","padding-bottom":"inherit","height":"inherit"},attrs:{"type":"is-ghost","icon-left":"content-copy","size":_vm.size},on:{"click":_vm.copy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }